export class GetAllEditorsUseCase{
  constructor(sectorRepository) {
    this.sectorRepository = sectorRepository
  }
  async execute(){
    const editors= await this.sectorRepository.getAllEditors()
    return editors

  }
}

